module.exports = __webpack_public_path__ + "img/series_5_1.25362f10.jpeg";